<div class="notification-container">
  <i [class]="data.iconClass + ' notification-icon'" [attr.aria-label]="'IMAGE_DESCRIPTION.ICON' | translate" role="img"></i>
  {{data.message}}
</div>